
/**
 * Created by Won on 8/12/2016.
 */
/* @ngInject */
export default function ParameterValueModelService() {
    return {
        getFormattedValue: function (value) {
            if (value.formattedValue !== undefined && value.formattedValue != null) {
                return value.formattedValue;
            }
            return value.value;
        }
    };
}
